import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/remote/auth.service';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  constructor(private _authService: AuthService) {}

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    console.debug('[LoginComponent] init, code:', code, 'state:', state);
    if (code && state) {
      // Prevent double redemption if component re-inits
      if (!sessionStorage.getItem('oauth_code_redeemed')) {
        sessionStorage.setItem('oauth_code_redeemed', '1');
        console.debug('[LoginComponent] Redeeming code');
        this._authService.exchangeCode(code, state);
      }
      // Clean URL to avoid reuse on manual reload
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }

  public loginWithMicrosoft = () => {
    this._authService.initiateMicrosoftLogin();
  }
}
